module.exports = __webpack_public_path__ + "4d6f237e06d6f77b20f59d2a33bb0c0a.svg";